"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var BindIdsDTO_1 = require("../../model/dto/BindIdsDTO");

var BindIdsDTOConverter_1 = require("./BindIdsDTOConverter");
/**
 * Implementation of BindIdsDTOConverter
 *
 * @author RV
 */


var BindIdsDTOConverterImpl =
/*#__PURE__*/
function (_BindIdsDTOConverter_) {
  _inherits(BindIdsDTOConverterImpl, _BindIdsDTOConverter_);

  function BindIdsDTOConverterImpl() {
    _classCallCheck(this, BindIdsDTOConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(BindIdsDTOConverterImpl).apply(this, arguments));
  }

  _createClass(BindIdsDTOConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new BindIdsDTO_1.BindIdsDTO(source.internalProductId, source.competitorProductId);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        internalProductId: source.internalProductId,
        competitorProductId: source.competitorProductId
      });
      return result;
    }
  }]);

  return BindIdsDTOConverterImpl;
}(BindIdsDTOConverter_1.BindIdsDTOConverter);

exports.BindIdsDTOConverterImpl = BindIdsDTOConverterImpl;